import React, { ChangeEvent, FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { WEBSITE } from '~/actions/actionTypes';
import { setMissingError } from '~/actions/errorActions';
import { setInput } from '~/actions/formActions';
import { IState } from '~/sharedInterfaces/IState';
import { IBaseComponent } from '../../sharedInterfaces/IBaseComponent';
import { IBaseInput } from '../../sharedInterfaces/SharedInterfaces';
import Input from '../Base/Input/Input';

export interface IWebsite extends IBaseInput {}

export interface IWebsiteProps extends IBaseComponent, IWebsite {}

const Website: FC<IWebsiteProps> = (props) => {
  const dispatch = useDispatch();

  const value = useSelector((state: IState) => state.signup.website || '');
  const error = useSelector((state: IState) => state.error.website?.missing);

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    dispatch(setInput(WEBSITE, inputValue));
    if (error) dispatch(setMissingError(WEBSITE, ''));
  };

  return (
    <Input
      {...props}
      value={value}
      error={error}
      onChange={handleOnChange}
      analyticsEvent="website"
      inputMode="url"
    />
  );
};

export default Website;
